export const requireConfigFiles = () =>
  require.context('../config/local', true, /.*?\.json$/)
